/** Register `location` for the in-feed sign-up CTA. */
export const MIXPANEL_REGISTER_LOCATION_FEED = "Feed" as const;

/** Register `location` for mobile/desktop Google one-tap sign-up modals and drawers. */
export const MIXPANEL_REGISTER_LOCATION_GOOGLE_ONE_TAP_MODAL = "Google 1-Tap Modal" as const;

/** Register `location` when a guest taps Scoreboard Save it. */
export const MIXPANEL_REGISTER_LOCATION_SCOREBOARD_SAVE = "Scoreboard Save" as const;

/** Register `location` when a guest taps Save it on the streak modal. */
export const MIXPANEL_REGISTER_LOCATION_STREAK_MODAL = "Streak Modal" as const;

/** Register `location` when a guest taps property like then signs up. */
export const MIXPANEL_REGISTER_LOCATION_LIKE_GATE_PROPERTY = "Like Gate-Property" as const;

/** Register `location` when a guest taps comment like then signs up. */
export const MIXPANEL_REGISTER_LOCATION_LIKE_GATE_COMMENT = "Like Gate-Comment" as const;

/** Register `location` when a guest taps the comment input then signs up. */
export const MIXPANEL_REGISTER_LOCATION_COMMENT_GATE = "Comment Gate" as const;

/** Register `location` when a guest signs up via the mobile puzzle page sticky banner. */
export const MIXPANEL_REGISTER_LOCATION_MOBILE_PUZZLE_BANNER = "Mobile Puzzle Banner" as const;

export type MixpanelLikeUnlikeLocation = "Feed" | "Scoreboard" | "Puzzle Page";

export type MixpanelLikeUnlikeContentType = "puzzle" | "comment";

export type MixpanelLikeUnlikeActionType = "Like" | "Unlike";

/** `source` on Signup Prompt Shown / Signup Prompt CTA Clicked (guest signup walls). */
export type MixpanelSignupPromptSource = "like" | "comment" | "scoreboard" | "follow" | "profile_view";
